import React from "react"
import clsx from "utils/clsx"

type PaperType = {
  children?: React.ReactNode
  className?: string
}
const Paper = ({ children, className }: PaperType) => {
  return (
    <div className={clsx("bg-white rounded-lg shadow-none", className)}>
      {children}
    </div>
  )
}

export default Paper
